<template>
  <footer id="footer" class="bg-accent text-white py-12">
    <div class="max-w-7xl mx-auto px-5">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div id="footer-brand">
          <div class="flex items-center space-x-3 mb-4">
            <div
              class="w-8 h-8 bg-primary rounded-lg flex items-center justify-center"
            >
              <i class="fas fa-leaf text-white"></i>
            </div>
            <span class="text-lg font-semibold">{{ $t('footer.brand.title') }}</span>
          </div>
          <p class="text-gray-300 text-sm">
            {{ $t('footer.brand.description') }}
          </p>
        </div>

        <div id="footer-support">
          <h3 class="font-semibold mb-4">{{ $t('footer.support.title') }}</h3>
          <ul class="space-y-2 text-sm text-gray-300">
            <li>
              <span class="hover:text-white cursor-pointer">{{ $t('footer.support.help_center') }}</span>
            </li>
            <li>
              <span class="hover:text-white cursor-pointer"
                >{{ $t('footer.support.contact_support') }}</span
              >
            </li>
            <li>
              <span class="hover:text-white cursor-pointer">{{ $t('footer.support.submit_ticket') }}</span>
            </li>
            <li>
              <span class="hover:text-white cursor-pointer">{{ $t('footer.support.system_status') }}</span>
            </li>
          </ul>
        </div>

        <div id="footer-legal">
          <h3 class="font-semibold mb-4">{{ $t('footer.legal.title') }}</h3>
          <ul class="space-y-2 text-sm text-gray-300">
            <li>
              <span class="hover:text-white cursor-pointer"
                >{{ $t('footer.legal.privacy_policy') }}</span
              >
            </li>
            <li>
              <span class="hover:text-white cursor-pointer"
                >{{ $t('footer.legal.terms_of_service') }}</span
              >
            </li>
            <li>
              <span class="hover:text-white cursor-pointer">{{ $t('footer.legal.cookie_policy') }}</span>
            </li>
            <li>
              <span class="hover:text-white cursor-pointer">{{ $t('footer.legal.disclaimer') }}</span>
            </li>
          </ul>
        </div>

        <div id="footer-connect">
          <h3 class="font-semibold mb-4">{{ $t('footer.connect.title') }}</h3>
          <div class="flex space-x-4">
            <span class="text-gray-300 hover:text-white cursor-pointer">
              <i class="fab fa-twitter text-lg"></i>
            </span>
            <span class="text-gray-300 hover:text-white cursor-pointer">
              <i class="fab fa-linkedin text-lg"></i>
            </span>
            <span class="text-gray-300 hover:text-white cursor-pointer">
              <i class="fab fa-youtube text-lg"></i>
            </span>
          </div>
        </div>
      </div>

      <div
        class="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400"
      >
        <p>{{ $t('footer.copyright', { year: new Date().getFullYear() }) }}</p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
/* Component-specific styles if needed */
</style>
